import { render, staticRenderFns } from "./CheckoutPagamento.vue?vue&type=template&id=1b30b8ab&"
import script from "./CheckoutPagamento.vue?vue&type=script&lang=js&"
export * from "./CheckoutPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports